<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="basic-paragraph"><span class="title">Everlasting</span></p>
<p class="basic-paragraph"><span class="title">QUILTS</span><span class="title"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="char-style-override"></span></p>
<p class="basic-paragraph"><span class="byline">a novel by</span></p>
<p class="basic-paragraph"><span class="authorname">Ann Hazelwood</span></p>
</div>
<div class="frame">
<img alt="45008.png" class="frame1" src="OEBPS/image/45008.png"/>
</div>
<div class="frame">
<img alt="Image" class="calibre1" src="CT_Logo.jpg"/>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="basic-text-frame">
<p class="normal"></p>
</div>
<div class="basic-text-frame">
<p class="basic-paragraph1"><span class="body-copy"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// everlastingquilts.vue?289ef9a1